import { Asset } from '../asset/types';

export interface SellOffer {
  asset: Asset; 
  asset_id: string; // 0xf971aef926f12effe0e8689d7b2ceac089e75f60
  available: number; // 3
  brand: string; // 'exporo' || 'propvest'
  created_at: string; // "2022-01-12 14:36:14"
  dda_id: number // 23509bc0-7244-11eb-b583-052f63ad90a3
  delivered: number // 2
  expires_at: string // "2022-01-12 14:36:14"
  id: number; // 12345
  initial_max_pieces: number; // 5
  security_wallet: string; // 0xe6d0a8f1c7ae8891ce5612771f78ad9177278fce
  state: string; // 'Opened'
  total: number; // 1234
  trading: number; // 2
  unit_price: number; // 1222
  updated_at: string; // "2022-01-12 14:36:14"
  user_id: number;
  vault_wallet_name: string; // "170365"
  wallet: string; // "78961142";
}

export interface BuyOffer {
  asset: Asset; 
  available: number // 74
  created_at: string // "2022-03-23 16:28:41"
  dda_id: string // "ef76ee40-8231-11ec-9680-09c288c0676d"
  delivered: number // 0
  expires_at: string // "2022-06-21 00:00:00"
  financial_product_id: string // "3qoxe9kpraf7qu"
  id: number // 152
  initial_max_pieces: number // 74
  reserved_balance_escrow_id: number // 39127
  reserved_balance_escrow_wallet_id: number // 2290486656
  security_wallet: string // "0xd57e7cb73b3f28f34bdfb3dfd1068e853d263511"
  state: string // "Opened"
  total: number // 7104
  trading: number // 0
  unit_price: number // 96
  updated_at: string // "2022-03-23 16:29:44"
  user_id: number // 139856
  vault_wallet_name: string // "139856-ROBO-ef76ee40-8231-11ec-9680-09c288c0676d"
  wallet: string // "2162841331"
}

export interface CreateSellOffer {
  asset_id: string;
  available: number;
  unit_price: number;
}
export interface TradeSellOffer {
  pieces: number;
}

export interface Trade {
  sell_offer?: SellOffer,
  buy_offer?: BuyOffer,
  id: number;
  wallet: number;
  user_id: number;
  state: string;
  pieces: number;
  unit_price: number;
  total: number;
  sell_offer_id: number;
  buy_offer_id?: number;
  created_at: string;
  updated_at: string;
  security_wallet?: string,
  escrow_id?: number
}

export interface SellOfferState {
  sellOffer?: SellOffer,
  trades?: Trade[],
  createdSellOffer?: SellOffer,
  createdTradeSellOffer?: boolean,
  verifiedTrades?: Trade[],
  errorCreatingTradeSellOffer?: string,
  errorCreatingSellOffer?: string,
  errorLoadingSellOffer?: string
}

export enum TradeState {
  Active = 'Active',
  Pending = 'Pending',
} 